import React from 'react';
import { Crisp } from 'crisp-sdk-web';
import { useEffect, useRef, useState } from 'react';
import {
  useAuthenticationContext,
  useEventsSubscriber,
  LOGGED_OUT,
  useConfigurationContext
} from 'nekst-api';
import { TextLink } from 'ui-builder';
import { useLocation } from 'react-router-dom';
import { CHAT_WIDGET_OPENED, CHAT_WIDGET_CLOSED } from 'features/nekst-widgets';

export default function CrispChat() {
  const authenticationContext = useAuthenticationContext();

  const [isInit, setInit] = useState(false);
  const chatWidgetOpenRef = useRef(false);
  const location = useLocation();

  const configuration = useConfigurationContext();

  const resetSession = () => {
    if (typeof window.$crisp.do === 'function' && Crisp?.session) {
      Crisp.session.reset(false);
    }
  };

  useEffect(() => {
    if (configuration.isChatEnabled && configuration.crispWebsiteId) {
      Crisp.configure(configuration.crispWebsiteId, {
        locale: 'en',
        sessionMerge: true,
      });
      setInit(true);
    }

  }, [configuration.isChatEnabled]);

  useEventsSubscriber(
    'CrispChat',
    {
      [LOGGED_OUT]: () => {
        // @ts-ignore
        delete window.CRISP_TOKEN_ID;
        resetSession();
      },
      [CHAT_WIDGET_OPENED]: () => {
        chatWidgetOpenRef.current = true;
        if (isInit) {
          Crisp.chat.hide();
        }
      },
      [CHAT_WIDGET_CLOSED]: () => {
        chatWidgetOpenRef.current = false;
        if (isInit && !location.pathname.startsWith('/chats')) {
          Crisp.chat.show();
        }
      },
    },
    [JSON.stringify(authenticationContext?.user), isInit, location.pathname],
  );

  useEffect(() => {
    if (isInit) {
      const user = authenticationContext?.user;

      if (user) {
        resetSession();
        Crisp.user.setEmail(user.profile.primaryEmail, user._crispEmailSignature);
        Crisp.user.setNickname(user.profile.name.fullName);
      }
    }
  }, [JSON.stringify(authenticationContext?.user), isInit]);

  useEffect(() => {
    if (isInit) {
      if (location.pathname.startsWith('/chats') || chatWidgetOpenRef.current) {
        Crisp.chat.hide();
      } else {
        Crisp.chat.show();
      }
    }
  }, [location.pathname, isInit]);

  return null;
}

export function OpenChatLink(props: {
  children: string
}) {
  return (
    <TextLink
      onClick={async () => {
        // open Crisp chat
        Crisp.chat.open();
      }}
    >
      {props.children}
    </TextLink>
  )
}
